import Vue from "vue";
import Router from "vue-router";
//Main Page
import core from "../views/core.vue";
//Login components
import login from "../views/user-views/login.vue";
import register from "../views/user-views/register.vue";
import resetPassword from "../views/user-views/resetPassword.vue";
import compProfile from "../views/user-views/comp_profile.vue";
import changepassword from "../views/user-views/changepassword.vue";
import forgotPassword from "../views/user-views/forgotPassword.vue";
import recoveryPassword from "../views/user-views/comp_recoveryPassword.vue";
//Components
import home_page from "../views/home-page/home_page.vue";
import category from "../components/Categories/categories.vue";
import categoryT2 from "../components/Categories/categoriesT2.vue";
import categoryT3 from "../components/Categories/categoriesT3.vue";
import categoryPDI from "../components/Categories/categoriesPDI.vue";
import categoryT2PDI from "../components/Categories/categoriesT2PDI.vue";
import categoryT3PDI from "../components/Categories/categoriesT3PDI.vue";
import brands from "../components/Brands/brands.vue";
import quickorder2 from "../components/quickorder/quickOrder2.vue";
import traking from "../components/tracking/tracking.vue";
import productShow from "../components/product/productShow.vue";
import productDetail from "../components/product-details/comp_productDetail.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      component: core,
      children: [
        {
          path: "/",
          name: "category",
          component: category,
          meta: {
            requiresAuth: false,
          },
        },
        {
          path: "/category/",
          name: "category",
          component: category,
        },
        {
          path: "/category/:categoryT2",
          name: "categoryT2",
          component: categoryT2,
        },
        {
          path: "/category/:categoryT2/:categoryT3",
          name: "categoryT3",
          component: categoryT3,
        },
        {
          path: "/PDI/",
          name: "PDI",
          component: categoryPDI,
        },
        {
          path: "/PDI/:PDIT2",
          name: "PDIT2",
          component: categoryT2PDI,
        },
        {
          path: "/PDI/:PDIT2/:PDIT3",
          name: "PDIT3",
          component: categoryT3PDI,
        },
        {
          path: "/brands/",
          name: "brands",
          component: brands,
        },
        {
          path: "/list",
          name: "quickorder2",
          component: quickorder2,
          meta: {
            requiresAuth: false,
          },
        },
        {
          path: "/tracking/",
          name: "traking",
          component: traking,
        },
        {
          path: "/products",
          name: "products",
          component: productShow,
        },
        {
          path: "/products/category/:category",
          name: "productShowCategory",
          component: productShow,
        },
        {
          path: "/products/brands/:brand",
          name: "productShowBrand",
          component: productShow,
        },
        {
          path: "/promo",
          name: "promo",
          component: productShow,
        },
        {
          path: "/productDetail/:sku",
          name: "productDetail",
          component: productDetail,
        },
        {
          path: "/login",
          name: "login",
          component: login,
          meta: {
            requiresAuth: false,
          },
        },
        {
          path: "/register/",
          name: "register",
          component: register,
        },
        {
          path: "/resetPassword/:monthUpdate",
          name: "resetPassword",
          component: resetPassword,
        },
        {
          path: "/profile",
          name: "profile",
          component: compProfile,
          meta: {
            requiresAuth: false,
          },
        },
        {
          path: "/changepassword/",
          name: "changepassword",
          component: changepassword,
          meta: {
            requiresAuth: false,
          },
        },
        {
          path: "/forgotPassword",
          name: "forgotPassword",
          component: forgotPassword,
        },
        {
          path: "/recoveryPassword/",
          name: "recoveryPassword",
          component: recoveryPassword,
        },
      ],
    },
    {
      path: "/loginApp",
      component: login,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/registerApp",
      component: register,
    },
    {
      path: "/resetPasswordApp",
      component: recoveryPassword,
    },
    {
      path: "/recoveryPasswordApp",
      name: "recoveryPassword",
      component: recoveryPassword,
    },
  ],
});
